import React from 'react';
import JobActionButton, {
    JobActionButtonProps,
} from '../../../Jobs/JobActionButton';
import ButtonWithForm from '../../../../common/General/ButtonWithForm';
import CcCluster from '../../../../services/models/CcCluster';
import { CmonJobInstanceCommand } from '../../../../services/cmon/models/CmonJobInstance';
import BackupToolPgBackrestSetupModal from '../BackupToolPgBackrestSetupModal';

export default BackupToolPbBackrestSetupActionButton;

export type BackupToolPbBackrestSetupActionButtonProps = Omit<
    JobActionButtonProps,
    'command'
> & {
    cluster: CcCluster;
    children?: React.ReactNode;
    onSuccess?: () => void;
    reinstall?: boolean;
};

function BackupToolPbBackrestSetupActionButton({
    cluster,
    children,
    onSuccess,
    reinstall = false,
    ...rest
}: BackupToolPbBackrestSetupActionButtonProps) {
    return (
        <ButtonWithForm
            button={
                <JobActionButton
                    command={
                        CmonJobInstanceCommand.PGBACKREST.toLowerCase() as CmonJobInstanceCommand
                    }
                    clusterId={cluster.clusterId}
                    {...rest}
                >
                    {`${reinstall ? 'Reinstall' : 'Install'} PgBackRest`}
                </JobActionButton>
            }
            form={
                <BackupToolPgBackrestSetupModal
                    cluster={cluster}
                    reinstall={reinstall}
                    onSuccess={onSuccess}
                />
            }
        />
    );
}
